export default {
  standardPadding: 35,
  fontFamily: "NoeDisplayMedium"

}
